<template>
  <div
    v-scroll="onScroll"
  >
    <v-progress-linear
      v-if="searchCriteria.searching"
      :indeterminate="true"
    />
    <v-alert
      v-if="!searchCriteria.searching && !campsitesFiltered.length"
      :value="true"
      type="info"
    >
      <span>No Results for your search</span>
    </v-alert>
    <!-- start list view -->
    <template v-if="searchCriteria.view == 'list'">
      <Card
        v-for="campsite in campsitesFiltered.slice(0, resultsToShow)"
        :key="campsite.campsiteID"
        class="search-result">
        <template slot="header">
          {{ campsite.campgroundName }} | {{ campsite.campsiteNumber }} {{ campsite.campsiteName }}
        </template>
        <v-layout
          align-center
          justify-center
          row
          wrap>
          <v-flex xs3>
            Type: {{ campsite.campsiteTypeWord }}<br>
            Capacity: {{ campsite.campsiteCapacity }}<br>
            Summer Price: ${{ campsite.summerPrice }}<br>
            Winter Price: ${{ campsite.winterPrice }}<br>
          </v-flex>
          <v-flex>
            {{ campsite.campsiteDetails }}<br>
          </v-flex>
          <v-flex xs3>
            <campsiteIcons :campsite="campsite"/>
          </v-flex>
        </v-layout>
        <!-- start reserve blocks -->
        <v-layout
          align-center
          row
          wrap>
          <v-flex
            v-for="(day, dayIndex) in week"
            :key="dayIndex"
            :class="{'hidden-sm-only' : dayIndex >= 5, 'hidden-xs-only': dayIndex >= 3}"
            class="my-4"
          >
            <ReserveBlock>
              <template slot="header">
                {{ day.format('ddd') }}<br>
                {{ day.format('YYYY-MM-DD') }}
              </template>
              <CampingReserveIcon
                :reserve-date="day"
                :rolling-date="rollingDate"
                :current-datetime="currentDatetime"
                :campsite-i-d="campsite.campsiteID"
                :open-date="$moment(day.year() + campsite.startDate.substring(4))"
                :close-date="$moment(day.year() + campsite.endDate.substring(4))"
                :bookings="campsite.bookings"
                :blackouts="campsite.blackouts"
              />
            </ReserveBlock>
          </v-flex>
        </v-layout>
        <!-- end reserve blocks -->
      </Card>
    </template>
    <!-- end list view -->
    <!-- start table view -->
    <template v-if="searchCriteria.view == 'table'">
      <v-card>
        <v-data-table
          :headers="headers"
          :items="campsitesFiltered.slice(0, resultsToShow)"
          class="elevation-1"
          hide-actions
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td>
              {{ props.item.campgroundName }} | {{ props.item.campsiteNumber }} {{ props.item.campsiteName }}<br>
              {{ props.item.campsiteTypeWord }} | Capacity: {{ props.item.campsiteCapacity }}</td>
            <td class="text-xs-right">
              S:${{ props.item.summerPrice }}<br>
              W:${{ props.item.winterPrice }}</td>
            <td>
              {{ props.item.campsiteDetails }}<br>
              <campsiteIcons :campsite="props.item"/>
            </td>
            <!-- start reserve blocks -->
            <td>
              <v-layout>
                <v-flex
                  v-for="(day, dayIndex) in week"
                  :key="dayIndex"
                  :class="{'hidden-sm-only' : dayIndex >= 5, 'hidden-xs-only': dayIndex >= 3}"
                  class="pa-0"
                >
                  <v-layout
                    column
                    align-center
                  >
                    <v-flex>{{ day.format('ddd') }}</v-flex>
                    <v-flex>{{ day.format('MM-DD') }}</v-flex>
                    <CampingReserveIcon
                      :reserve-date="day"
                      :rolling-date="rollingDate"
                      :current-datetime="currentDatetime"
                      :campsite-i-d="props.item.campsiteID"
                      :open-date="$moment(day.year() + props.item.startDate.substring(4))"
                      :close-date="$moment(day.year() + props.item.endDate.substring(4))"
                      :bookings="props.item.bookings"
                      :blackouts="props.item.blackouts"
                      small
                      @add="reserve"
                      @remove="deleteCampsiteBooking"
                    />
                  </v-layout>
                </v-flex>
              </v-layout>
            </td>
            <!-- end reserve blocks -->
          </template>
        </v-data-table>
      </v-card>
    </template>
    <!-- end table view -->
  </div>
</template>

<script>
// import vuex mapping
import CampingReserveIcon from './CampingReserveIcon'
import { mapActions, mapGetters } from 'vuex'
// our new component
export default {
  components: {
    CampingReserveIcon
  },
  data () {
    return {
      resultsToShow: 5,
      campsiteWeekPoller: null,
      headers: [
        {
          text: 'Campsite',
          align: 'left',
          sortable: false,
          value: 'campgroundName'
        },
        {
          text: 'Price',
          align: 'right',
          sortable: false,
          value: 'campsiteType'
        },
        {
          text: 'Details',
          align: 'left',
          sortable: false,
          value: 'campsiteDetails'
        },
        {
          text: 'Reserve',
          align: 'center',
          sortable: false,
          value: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      campsitesFiltered: 'facilities/campsitesFiltered',
      searchCriteria: 'facilities/searchCriteria'
    }),
    week () {
      var week = []
      // derive the week
      for (var i = 0; i <= 6; i++) {
        var dateObject = this.$moment.tz(this.searchCriteria.date, 'America/New_York')
        dateObject.add(i, 'days')
        week.push(dateObject)
      }
      return week
    },
    rollingDate () {
      return this.$moment.tz('America/New_York').add(this.settings.campingRollingPeriod, 'months')
    },
    currentDatetime () {
      return this.$moment.tz('America/New_York')
    }
  },
  mounted () {
    this.campsiteWeekPoller = setInterval(this.getCampsiteWeek, 30000)
  },
  beforeDestroy () {
    clearInterval(this.campsiteWeekPoller)
  },
  methods: {
    onScroll (e) {
      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight - 100) {
        this.resultsToShow += 5
      }
    },
    ...mapActions({
      getCampsiteWeek: 'facilities/getCampsiteWeek'
    })
  }
}
</script>
